import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

export const bankAccountDetailsRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `/$bankAccountId`,
    component: lazyRouteComponent(() => import('./Details'))
  })
